import { useEffect, useState } from "react";

import { useBlizzardEvents } from "../../analytics/hooks";

export const useCommunityAudiencePageBlizzardEvent = (): void => {
    const [viewedOnce, setViewedOnce] = useState(false);

    const { sendBlizzardEvent } = useBlizzardEvents();

    useEffect(() => {
        if (!viewedOnce) {
            sendBlizzardEvent({
                event: "MYLENSES_COMMUNITY_AUDIENCE_PAGE_VIEW",
            });
            setViewedOnce(true);
        }
    }, [sendBlizzardEvent, setViewedOnce, viewedOnce]);
};
